import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { Link, withRouter } from 'react-router-dom'
import firebase from '../firebase'
import { isUserAdmin } from '../firebaseHelpers'
import UploadModal from '../components/UploadModal'
import LoadingWheel from '../components/LoadingWheel'
import LowResolutionWarning from '../components/LowResolutionWarning'
import EditorContext from '../contexts/EditorContext'
import { getTotalPrice, getMinQty, get8x8Price, get12x12Price } from '../helpers/pricing'
import { Cart, Close, Truck } from '../icons'
import * as photosActions from '../actions/photosActions'
import logo from '../svgs/logo2.svg'
import placeholder from '../svgs/placeholder.svg'

const modifyOrder = firebase.functions().httpsCallable('modifyOrder');

class Header extends Component {
	constructor() {
  	super();

  	this.state = {
  		showMenu: false,
  		showSizePopup: false,
  		showCartPopup: false,
  		isAccount: false,
  		isAdmin: false,
  		isAuth: false,
  		isCart: false,
  		isConfirmation: false,
  		isOrderPreview: false,
  		isUserAdmin: false,
  		showImportJson: false
  	};
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(async (user) => {
			this.context.setState({ isUserConnected: !!user });

			const isAdmin = await isUserAdmin();
			this.setState({ isUserAdmin: isAdmin });
    })

		const handleLocation = ({pathname}) => {
			this.props.onToggleAuthModal(
				['/auth', '/reset-password'].indexOf(pathname) !== -1,
				pathname === '/reset-password' ? 'reset-form' : 'login'
			);

			this.setState({
				isAccount: pathname.indexOf('/account') !== -1,
				isAdmin: pathname.indexOf('/admin') !== -1,
				isAuth: pathname.indexOf('/auth') !== -1,
				isCart: pathname.indexOf('/cart') !== -1,
				isConfirmation: pathname.indexOf('/confirmation') !== -1,
				isOrderPreview: pathname.indexOf('/order-confirmation') !== -1
			});
		}

		handleLocation(this.props.location);
		this.props.history.listen(handleLocation);
	}

	onAdd = () => {
		document.getElementsByClassName('file-uploader')[0].click();
	}

	onReset = () => {
		this.setState({ showMenu: false });
		this.props.photosActions.receivePhotos([]);
		// this.props.history.push('/upload');
	}

	onSelectSize = size => {
		this.context.setState({ size });
		this.setState({ showSizePopup: false });

		if (this.context.orderId) {
			this.context.setState({ loading: true });
			modifyOrder({
	      id: this.context.orderId,
	      token: this.context.orderToken,
	      tileSize: size
	    }).then(({data}) => {
	      this.context.setState({ 
	      	price: data.price,
	      	loading: false
	      });
	    }).catch(error => {
	    	this.context.setState({ loading: false });
	      alert(JSON.stringify(error));
	    });
		}
	}

	render() {
		const { 
			showMenu, 
			showSizePopup, 
			showCartPopup, 
			isAccount, 
			isAdmin, 
			isAuth, 
			isConfirmation,
			isOrderPreview,
			isCart,
			isUserAdmin,
			showImportJson
		} = this.state;
		const { photos, onToggleShowInfo, onToggleAuthModal } = this.props;
    	
  	return (
  		<header className={ 'header' + (showMenu ? ' menu-opened' : '') }>
  			<EditorContext.Consumer>
					{context => (
						<>
			        <div className="site-content top-part clearfix">
			          <div className="logo-wrapper">
			            <Link 
			            	to={'/gallery/' + context.getPhotoTilesCollectionId()} 
			            	onClick={() => context.setState({selectedCollection: context.getPhotoTilesCollectionId()})}
			            	className="logo"
		            	>
			            	<img src={ logo } alt="SweetPix" width="140" height="48" />
			        	  </Link>
			        	  {
			        	  	isAccount || isAdmin || isAuth || isOrderPreview
			        	  	? null
			        	  	: <div className="size-info">
			        	  		<strong>Photo Tiles</strong>
											<div>
												Square { context.size }"
												&nbsp;&nbsp;&nbsp;
												<div className="size-selector">
													{
														!isConfirmation
														? <span className="trigger" onClick={ () => this.setState({ showSizePopup: !showSizePopup }) }>
															Change Size
														</span>
														: null
													}
													{
														showSizePopup
														? <div className="tooltip-popup tooltip-popup-size">
															<div className="tooltip-popup-title">SELECT PHOTO TILE SIZE</div>
															<div className="tooltip-popup-desc">Two popular sizes to choose from, since they stick with no damage to walls you can mix and match.</div>
															<article className={classNames('size-8x8', { active: context.size === '8x8' })} onClick={() => this.onSelectSize('8x8')}>
																<div className="size-main-info">
																	<figure>
																		<img src={ placeholder } alt="Placeholder" />
																	</figure>
																	<div className="size-type">
																		<div className="size-type-value">8 x 8 in.</div>
																		<div className="size-info-line">The first 2 are $25 </div>
																	</div>
																</div>
																<div className="size-price">
																	<div className="size-price-value">${ get8x8Price() }</div>
																	<div className="size-info-line">each</div>
																</div>
															</article>
															<div className="separator"></div>
															<article className={classNames('size-12x12', { active: context.size === '12x12' })} onClick={() => this.onSelectSize('12x12')}>
																<div className="size-main-info">
																	<figure>
																		<img src={ placeholder } alt="Placeholder" />
																	</figure>
																	<div className="size-type">
																		<div className="size-type-value">12 x 12 in.</div>
																		<div className="size-info-line">1 tile minimum</div>
																	</div>
																</div>
																<div className="size-price">
																	<div className="size-price-value">${ get12x12Price() }</div>
																	<div className="size-info-line">each</div>
																</div>
															</article>
															<div className="shipping-info">
																Free shipping in the US
																<Truck />
															</div>
														</div>
														: null
													}
												</div>
											</div>
										</div>
			        	  }
								</div>

								<div className="header-action">
									{
										!context.isUserConnected && !isAuth && !isOrderPreview
										? <button className="sp-button bordered blue" onClick={() => onToggleAuthModal()}>Login</button>
										: null
									}
									{
										isAccount && isUserAdmin
										? <>
											<span className="sp-button bordered blue" onClick={() => this.setState({ showImportJson: true })}>Import Order Json</span>
											<Link to="/admin" className="sp-button bordered blue">Admin</Link>
										</>
										: null
									}
									{
										isAccount
										? <Link to="/" className="sp-button bordered blue">Back to Order</Link>
										: null
									}

									{
										isConfirmation
										? <Link to="/" className="sp-button bordered blue">+ New Order</Link>
										: null
									}

									{
										isAccount || isAdmin
										? <button className="sp-button bordered" onClick={ () => {
											firebase.auth().signOut().then(() => {
												this.context.loadSidebarCollections();
											  this.props.history.push('/');
											}).catch((error) => {
											  alert(JSON.stringify(error));
											});
										} }>Logout</button>
										: <>
											{
												isAuth || isConfirmation || isOrderPreview
												? null
												: <>
													{
														context.isUserConnected
														? <Fragment>
															{
																context.images.length > 0 && !isCart && context.orderId && context.orderToken
																? <Link className="sp-button bordered flex" to={ '/order-confirmation/preview-' + context.orderId + '/' + context.orderToken } target="_blank">
																	<span>Preview Order</span>
																</Link>
																: null
															}
															<Link to="/account" className="sp-button bordered flex">
																<span>My Account</span>
															</Link>
														</Fragment>
														: null
													}
													<div className={ 'cart-widget ' + (isCart ? 'floated' : '') }>
														<div className="cart-trigger" onClick={ () => this.setState({ showCartPopup: !showCartPopup }) }>
															<div className="cart-trigger-icon">
																<Cart />
															</div>
															<div className="cart-trigger-count">{ context.images.length }</div>
														</div>
														{
															showCartPopup
															? <div className="tooltip-popup tooltip-popup-cart">
																<div className="tooltip-popup-title">
																	<div>
																		<Cart />
																		SHOPPING CART
																	</div>
																	<div className="tooltip-popup-close" onClick={() => this.setState({ showCartPopup: false })}>
																		<Close />
																	</div>
																</div>

																{
																	context.collections.map(collection => {
																		const qty = context.getCollectionCartImagesCount(collection.id);

																		if (!qty) {
																			return null;
																		}

																		return (
																			<div className="cart-row" key={collection.id}>
																				<div className="cart-row-left">
																					<div className="cart-row-qty">{ qty }</div>
																					<div>
																						<div>{ collection.name }</div>
																						<div className="cart-row-size">
																							{ context.size } in | 
																							<span className="text-button" onClick={() => {
																								this.setState({ showCartPopup: false });
																								context.setState({showUploadModal: true});
																							}}>+ Add More</span>
																						</div>
																					</div>
																				</div>
																				<div className="cart-row-right">
																					<div>${ qty * context.getItemPrice() }</div>
																					<div className="cart-row-remove" onClick={() => context.removeCartRow(collection.id)}>
																						<Close />
																					</div>
																				</div>
																			</div>
																		);
																	})
																}

																<div className="cart-row cart-row-totals">
																	<div className="cart-row-left">
																		<div className="cart-row-qty">{ context.images.length }</div>
																		<div>Total Tiles</div>
																	</div>
																	<div className="cart-row-right">
																		<div>
																			<div>Subtotal</div>
																			<div>${ context.getSubtotalPrice() }</div>
																		</div>
																		<div>
																			<div>Shipping</div>
																			<div>${ this.context.getShippingPrice() }</div>
																		</div>
																	</div>
																</div>
																<div className="button-holder">
																	<Link to="/cart" className="sp-button bolder padding-l" onClick={() => this.setState({ showCartPopup: false })}>
																		Checkout
																	</Link>
																</div>
															</div>
															: null
														}
													</div>
													{
														isCart
														? null
														: <Link to="/cart" className="sp-button bolder padding-l flex">
															<span>${ context.getSubtotalPrice() } | Order</span>
														</Link>
													}
												</>
											}
										</>
									}
								</div>

			      	  { showMenu ? <div className="menu-overlay"></div> : null }
			          {/*
			          <div className="menu">
			            {
			              !showMenu
			              ? (<div className="trigger" onClick={ () => { this.setState({ showMenu: true }); } }>
			                  <span></span>
			                  <span></span>
			                  <span></span>
			                </div>)
			              : (<div className="dropdown">
			                  <span className="close" onClick={ () => { this.setState({ showMenu: false }); } }>
			                    <img src={ icon } alt="Close" />
			                  </span>
			                  <ul>
			                    {
			                    	this.props.location.pathname !== '/'
			                    	? <li>
			                      		<span onClick={ this.onReset }>Start Over</span>
			                    	</li>
			                    	: null
			                  	}
			                    <li>
			                      <a target="_blank" rel="noopener noreferrer" href="https://sweetpixapp.com/faq">FAQ</a>
			                    </li>
			                    <li>
			                      <a href="mailto:support@sweetpixapp.com">Need Help</a>
			                    </li>
			                  </ul>
			                </div>)
			              }
			          </div>
			        	*/ }
			        </div>

			        <div className="order-bar">
			        	<div className="site-content clearfix">
			        		<div className="order-info">
			        			<div className="line1">
			        				ORDER DETAILS
			        				<img onClick={ onToggleShowInfo } src="data:image/png;base64,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" alt="Info" />
			      				</div>
			        			{
			        				photos.length < getMinQty()
			        				? <div className="line2">Select 1 or more tiles to continue</div>
			        				: <div className="line2">{ photos.length } Photo { photos.length === 1 ? 'tile' : 'tiles' } = ${ getTotalPrice(photos) }</div>
			        			}
									</div>
									<div className="buttons">
										<button onClick={ this.onAdd } className="action-button size-x green">ADD MORE +</button>
										<Link to="checkout" className="action-button size-x">CHECKOUT</Link>
									</div>
			  				</div>
			    		</div>

			    		{
				        showImportJson
				        ? <div className="modal-overlay">
				          <div className="modal-content">
				            <div className="module-inner">
				              <textarea id="import-json-textarea"></textarea>
				              <div className="centered-button-holder spaced">
				                <span className="text-button" onClick={() => this.context.setLocalData(document.getElementById('import-json-textarea').value)}>Import</span>
				                <span className="text-button" onClick={() => this.setState({showImportJson: false})}>Close</span>
				              </div>
				            </div>
				          </div>
				        </div>
				        : null
				      }
			    		
			    		{
			    			context.showUploadModal
			    			? <UploadModal />
			    			: null
			    		}

		    			<LowResolutionWarning />

			    		{
			    			context.loading || context.loadingImageCollectionImages
			    			? <LoadingWheel />
			    			: null
			    		}
		    		</>
	    		)}
				</EditorContext.Consumer>
    	</header>
		)
	}
}

Header.contextType = EditorContext;

function mapStateToProps(state, action) {
  return {
    photos: state.photos
  }
}
function mapDispatchToProps(dispatch) {
  return {
  	photosActions: bindActionCreators(photosActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Header));
